import React, { useCallback, useEffect, useRef, useState } from 'react'
import Button from '../../Components/common/Button'
import Table from '../../Components/common/tableWithBackEndPagination'
import { Box, Card, CardContent, Chip, Grid, Stack, Typography } from '@mui/material'
import axios from 'axios';
import instance from '../../axios';
import Loader from '../../Layout/Loader';
// import { CreateReminderMaintenance } from './CreateReminderMaintenance';
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations';
import ConfirmDialoag from '../../Components/common/ConfirmDialoag';
import { checkPrivileges, errorHandler, showDates } from '../../Helpers';
import { CheckCircle } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import EnhancedTable from './Table';
import moment from 'moment';


const checkFloteNumber = (n) => {
    return Number(n) === n && n % 1 !== 0;
}
let vehiclesList = [];
const servicesAttributes = [];
let expenseType = []
let formDefault = {
    attributes: {
        mileage: 0,
        hours: 0,
        date: 0,
        status: true,
        mailTo: "",
        notificators: "mail",
    },
}
const buildQuery = (filters) => {
    let qs = "";

    if (filters?.searchValue) qs += `&deliveryNoteNumber=${filters.searchValue}`;
    if (filters?.searchPlateNumber) qs += `&plateNumber=${filters.searchPlateNumber}`;
    if (filters?.from) qs += `&from=${filters.from}`;
    if (filters?.to) qs += `&to=${filters.to}`;
    if (filters?.verticals) qs += filters.verticals;

    return qs;
};
const buildUrl = (selectedOrder, page, perPage, filters) => {
    const query = buildQuery(filters);
    return `/api/poinvoices/getpoitems?poReqId=${selectedOrder}&page=${page}&limit=${perPage}${query}`;
};
const columns = [
    { id: "deliveryNoteNumber", numeric: false, disablePadding: false, label: "deliveryNoteNo" },
    // { id: "contractNumber", numeric: false, disablePadding: false, label: "contractNumber" },
    { id: "plateNumber", numeric: false, disablePadding: false, label: "plateNumber" },
    { id: "attributes.saleTotal", numeric: false, disablePadding: false, label: "totalAmount" },
    { id: "attributes.saleVat", numeric: false, disablePadding: false, label: "VAT Amount" },
    { id: "attributes.saleNet", numeric: false, disablePadding: false, label: "amount" },
    { id: "serviceDate", numeric: false, disablePadding: false, label: "serviceDate" },
    { id: "invoiceMade", numeric: false, disablePadding: false, label: "invoiced" },


];

const createRowDefinition = (translate) => [
         {
        id: "poNumber",
        numeric: false,
        disablePadding: false,
        label: translate("soNumber"),
    },
         {
        id: "poRefNumber",
        numeric: false,
        disablePadding: false,
        label: translate("soRefNumber"),
    },
    {
        id: "contractNumber",
        numeric: false,
        disablePadding: false,
        label: translate("contractNumber"),
    },
    {
        id: "attributes.counts",
        numeric: false,
        disablePadding: false,
        label: translate("dnsCount"),
    },
    {
        id: "attributes.estPrice",
        numeric: false,
        disablePadding: false,
        label: translate("estPrice"),
    },
    {
        id: "attributes.requestedBy",
        numeric: false,
        disablePadding: false,
        label: translate("requestedBy"),
    },
    {
        id: "created",
        numeric: false,
        disablePadding: false,
        label: translate("createdDate"),
    },
        {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: translate("status"),
    },
];
const SalesOrder = (props) => {
    const cancelSourceRef = useRef(null)
    const CancelToken = axios.CancelToken;
    const [reminders, setReminders] = useState({
        data: [],
        page: 1,
        pageSize: 20,
        total: 0,
        hasNext: false
    })
    const [saleOrderFilter, setSaleOrderFilter] = useState({
        fromDate: "",
        toDate: "",
        searchValue: "",
        searchPlateNumber: "",
        selectedDateTime: ""
    });
    const [loader, setLoader] = useState(false);
    const [isFetchingSaleItems, setIsFetchingSaleItems] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [itemPagination, setItemPagination] = useState({ items: [] });

    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [isCreateForm, setIsCreateForm] = useState(false)
    const [selectedUnit, setSelectedUnit] = useState(null)
    const [subTypes, setSubTypes] = useState([]);
    const [reminderForm, setReminderForm] = useState(formDefault)
    const [statusMode, setStatusMode] = useState(false)
    const [isVisible, setIsVisable] = useState(false)
    const [isDeleteReminder, setIsDeleteReminder] = useState(false)
    const [isChangeReminder, setIsChangeReminder] = useState(false)
    const [isViewListVehicleIds, setIsViewListVehicleIds] = useState(false)
    const [isEditForm, setIsEditForm] = useState(false)
    const [triggerApi, setTriggerApi] = useState(false);
    const [selectedReminder, setSelectedReminder] = useState(null)
    const [tags, setTags] = useState(null)
    const [filterTags, setFilterTags] = useState(null)
    const [showFilterModal, setShowFilterModal] = useState(false)
    const [scrollableVehiclesLength, setAllScrolableVehiclesLength] = useState(0)
const [poSearchValues,setPoSearchValues]=useState({
    soNumber:"",
    soRefNumber:""
})

    const handleShowTagFilter = () => setShowFilterModal(true)
    const handleCloseShowTagsFilter = () => setShowFilterModal(false)
    const [vehicleIds, setVehicleIds] = useState([])
    const vehicles = useSelector((state) => state.vehicles)
    const getVehicleName = (vehicleId) => {
        const vehicle = vehicles.find((v) => v.id === parseInt(vehicleId));
        return vehicle ? vehicle?.vehicleLicensePlate : "Unknown 🚗";
    }

    useEffect(() => {
        let source = CancelToken.source();

        const fetchReminders = async () => {
            setLoading(true);
            let toFromProps = props.to;
            let FromProps = props.from;

const toDate = toFromProps ? toFromProps.replace("&to=", "") : null;
const from = FromProps ? FromProps.replace("&from=", "") : null;

const params = {
  page: reminders.page,
  limit: reminders.pageSize,
  search: searchQuery || undefined,
};

if (toDate&&from) {
  params.to = toDate;
  params.from = from;
}
if(poSearchValues?.soNumber){
    params.poNumber=poSearchValues.soNumber
}
if(poSearchValues?.soRefNumber){
    params.soRefNumber=poSearchValues.soRefNumber
}
            try {
                const response = await instance({
                    url: "api/poinvoices/getporequests",
                    method: "GET",
                    cancelToken: source.token,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    params,
                })
                setReminders((prev) => ({
                    ...prev,
                    data: response.data,
                    total: response.total,
                    hasNext: response.hasNext,
                }));

            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error("Error fetching maintenance reminders:", error);
                }
                console.error(error)
            } finally {
                setLoading(false);
            }
        };

        fetchReminders();

        return () => source.cancel("API call cancelled")
    }, [reminders.page, reminders.pageSize, isCreateForm, triggerApi]);

    const setPagination = (data1) => {
        const { data } = reminders;
        if (data && data?.length) {
            let nUser = { ...data1 };
            let lastPage = nUser.total / reminders.pageSize;
            let IsFloate = checkFloteNumber(lastPage);
            delete nUser.data;
            nUser.pageSize = reminders.pageSize;
            nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
            return nUser;
        }
        return {};
    };

    const handleChangePage = (page) => {
        setReminders((prevState) => ({
            ...prevState,
            page
        }))
    }
    const handleChangeRowsPerPage = (pageSize) => {
        setReminders((prevState) => ({
            ...prevState,
            pageSize
        }))
    }
    const getVehiclesList = () => {
        vehiclesList = props.vehicles.map((item) => {
            return {
                id: item.id,
                label: item.vehicleLicensePlate,
                value: item.id,
                vehicleLP: item.vehicleLicensePlate,
                valueType: "string",
            };
        });
    };
    const createForm = () => {
        if (!vehiclesList.length && props.vehicles.length) {
            getVehiclesList();
        }
        setReminderForm(formDefault)
        setVehicleIds([])
        setStatusMode(false)
        setIsCreateForm((prev) => !prev)

    }

    const SearchItem = (value) => {
        setSearchQuery(value);
    };
    useEffect(()=>{
        setTriggerApi((prev) => !prev)
    },[props.from,props.to])
    const handleSearchApi = () => {
        setTriggerApi((prev) => !prev)
        setReminders((prevState) => ({
            ...prevState,
            page: 1
        }))
    }
    const handleStoreVehicleIds = (selectedVehicles) => {
        setVehicleIds(selectedVehicles);
        let updatedIds = selectedVehicles ? selectedVehicles.join(",") : "";
        setReminderForm((prevState) => ({
            ...prevState,
            attributes: {
                ...prevState.attributes,
                vehicleIds: updatedIds
            }
        }))

    };

    const handleChange = (name, value) => {
        let updatedValue = value;
        if (name === 'cost' && value < 0) {
            updatedValue = 0;
        }

        let units = {};
        units.id = updatedValue?.id;
        units.label = updatedValue.deviceName;
        units.value = updatedValue.deviceId;

        setSelectedUnit((prevState) => ({
            ...prevState,
            units,
        }));

        setReminderForm((prevState) => ({
            ...prevState,
            [name]: updatedValue,
        }));
    };

    const handleChangeAttributes = (name, value, checked) => {
        if (value) {
            if (name === "byMileage" || name === "byHours" || name === "byDays") {
                setReminderForm((prevState) => ({
                    ...prevState,
                    attributes: {
                        ...prevState.attributes,
                        [name]: checked,
                    },
                }));
            } else if (name === "serviceTypeId") {
                setSubTypes([])
                getSubTypes(value && value.id);
                setReminderForm(
                    (prevState) => ({
                        ...prevState,
                        cost: 0,
                        attributes: {
                            ...prevState.attributes,
                            serviceTypeId: value,
                            serviceExpenseTypeId: "",
                            typeName: value.name,
                        },
                    })
                );
            } else if (name === "serviceExpenseTypeId") {
                setReminderForm(
                    (prevState) => ({
                        ...prevState,
                        cost: value?.unitPrice || 0,
                        attributes: {
                            ...prevState.attributes,
                            serviceExpenseTypeId: value,
                            subtypeName: value.name
                        },
                    }),
                );
            } else {
                setReminderForm(
                    (prevState) => ({
                        ...prevState,
                        attributes: {
                            ...prevState.attributes,
                            [name]: value,
                        },
                    }),
                );
            }
        } else {
            setReminderForm((prevState) => {
                const updatedAttributes = { ...prevState.attributes };
                delete updatedAttributes[name];
                return {
                    ...prevState,
                    attributes: updatedAttributes,
                };
            });
        }
    };


    const getSubTypes = async (id) => {
        try {
            const response = await instance({
                method: "GET",
                url: `/api/expensetypes/subtype?expenseTypeId=${id}&search=`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            if (response) {
                const res = response.map((item) => ({
                    key: item.id,
                    id: item.id,
                    expenseTypeId: item.expenseTypeId,
                    name: item.label,
                    label: item.label,
                    parentId: item.parentId,
                    unitPrice: item.unitPrice || 0,
                }));
                setSubTypes(res); // Update state with the new subtypes
                return res; // Return the mapped result
            }
        } catch (error) {
            setSubTypes([]);
            return [];
        }
    };

    // useEffect(() => {
    //     getExpenseTypes()
    // }, [])

    const getExpenseTypes = (contractNumber) => {
        let userId = contractNumber
            ? contractNumber
            : props.ServerSettings && props.ServerSettings.contractNumber;
        instance({
            method: "GET",
            url: userId
                ? `/api/expensetypes?contractNumber=${userId}`
                : `/api/expensetypes`,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                response &&
                    response.map((type) => {
                        servicesAttributes.push({
                            key: type.id,
                            id: type.id,
                            type: type.type,
                            name: type.name,
                            subType: type.subType,
                        });
                    });

                let expenseTypes = response?.map((item) => {
                    return {
                        key: item.id,
                        id: item.id,
                        name: item.name,
                        description: item.description,
                        attributes: item.attributes,
                        parentId: item.parentId,
                        valueType: "string",
                        expenseType: item.expenseType,
                    };
                });
                expenseType = expenseTypes;
                // }
            })
            .catch((error) => {
                // errorHandler(error,props.dispatch)
            });
    };

    const saveToParent = (obj) => {
        setReminderForm((prevState) => ({
            ...prevState,
            attributes: { ...prevState.attributes, ...obj },
        }))
    };
    useEffect(() => {
        checkRequiredFields()
    }, [reminderForm])

    const checkRequiredFields = () => {
        let { name } = reminderForm;
        let {
            date,
            mileage,
            hours,
            byDays,
            byHours,
            byMileage,
            serviceExpenseTypeId,
            serviceTypeId,
            emails,
            mailTo,
            vehicleIds,
            notificators,
            avergeMileage,
            avergeDailyMileage,
        } = reminderForm && reminderForm.attributes;
        if (
            name &&
            vehicleIds?.length > 0 &&
            serviceExpenseTypeId &&
            serviceTypeId &&
            ((byMileage && mileage) ||
                (byHours && hours) ||
                (byDays && date) ||
                (avergeDailyMileage && avergeMileage))
        ) {
            if (
                notificators.includes("mail,whatsapp") &&
                mailTo === "custom" &&
                !emails
            ) {
                setIsVisable(true)
            } else {
                setIsVisable(false)
            }
        } else {
            setIsVisable(true)
        }
    };
    const [isBtnLoading, setIsbtnLoading] = useState(false)
    const submitForm = async () => {
        let obj = JSON.parse(JSON.stringify(reminderForm));

        if (obj.vehicleIds) {
            // obj.attributes.vehicleLicensePlate=obj.vehicleIds?.label
            // obj.vehicleIds = statusMode ? obj.vehicleIds : obj.vehicleIds.id;
            obj.deviceId = statusMode ? obj.deviceId : 0;
        }

        if (obj.attributes.byMileage && !statusMode) {
            obj.attributes.mileage = parseFloat(obj.attributes.mileage);
            obj.attributes.mileageInterval = parseFloat(obj.attributes.mileageInterval);
            obj.attributes.reminderBeforeMileage = parseFloat(obj.attributes.reminderBeforeMileage);
        }

        if (obj.attributes.byHours && !statusMode) {
            obj.attributes.hours = parseFloat(obj.attributes.hours * (1000 * 3600));
            obj.attributes.hoursInterval = parseFloat(obj.attributes.hoursInterval * (1000 * 3600));
            obj.attributes.reminderBeforeHours = parseFloat(obj.attributes.reminderBeforeHours * (1000 * 3600));
        }

        if (obj.attributes.byDays && !statusMode) {
            obj.attributes.date = obj.attributes.date;
            obj.attributes.daysInterval = parseFloat(obj.attributes.daysInterval) || parseFloat(1);
            obj.attributes.reminderBeforeDays = parseFloat(obj.attributes.reminderBeforeDays) || parseFloat(1);
        }

        if (obj.attributes.serviceExpenseTypeId) {
            obj.attributes.serviceExpenseTypeId = statusMode
                ? obj?.attributes?.serviceExpenseTypeId
                : obj?.attributes?.serviceExpenseTypeId?.id || "";
            obj.attributes.serviceTypeId = statusMode
                ? obj?.attributes?.serviceTypeId
                : obj?.attributes?.serviceTypeId?.id || "";
        }

        obj = {
            ...obj,
            type: "",
            // contractNumber:"pm2c101"
            // // contractNumber: props.logInUser.contractNumber
            // //     ? props.logInUser.contractNumber
            // //     : props.ServerSettings.contractNumber
            // //         ? props.ServerSettings.contractNumber
            // //         : "pm2c101",
        };

        obj.cost = parseFloat(obj.cost) || 0;
        delete obj.check;
        delete obj.parent;

        if (!obj.attributes.repeat) {
            delete obj.attributes.mileageInterval;
            delete obj.attributes.hoursInterval;
            delete obj.attributes.daysInterval;
        }
        if (!obj.attributes.byMileage) {
            delete obj.attributes.mileage;
            delete obj.attributes.mileageInterval;
            delete obj.attributes.reminderBeforeMileage;
            obj.attributes.reminderByMileage = false;
        }
        if (!obj.attributes.byHours) {
            delete obj.attributes.hours;
            delete obj.attributes.hoursInterval;
            delete obj.attributes.reminderBeforeHours;
            obj.attributes.reminderByHours = false;
        }
        if (!obj.attributes.byDays) {
            delete obj.attributes.date;
            delete obj.attributes.daysInterval;
            delete obj.attributes.reminderBeforeDays;
            obj.attributes.reminderByDays = false;
        }
        if (obj.attributes.email?.length === 0) {
            delete obj.attributes.email;
        }

        const url = isEditForm || statusMode ? `/api/maintenance/${selectedReminder?.id}` : `/api/maintenance`
        const method = isEditForm || statusMode ? `PUT` : `POST`
        setIsbtnLoading(true)
        try {
            const response = await instance({
                url: url,
                method: method,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: obj,
            });
            if (response) {
                if (!statusMode) {
                    createForm()
                }
                props.dispatch(notifySuccess(`Reminder ${isEditForm || statusMode ? "Updated" : "Created"} Successfully`));
                if (isEditForm || statusMode) {
                    setIsEditForm(false)
                    setStatusMode(false)
                    setIsChangeReminder(false)
                    setVehicleIds([])
                    setSelectedReminder(null)
                }
                setIsbtnLoading(false)
            }

        } catch (error) {
            props.dispatch(notifyError(error));
            setIsbtnLoading(false)

        }

    };



    const handleEditReminder = async (maintenanceForm) => {
        if (!vehiclesList.length && props.vehicles.length) {
            getVehiclesList();
        }
        getExpenseTypes();
        let selectedVehicle = props.vehicles.find(item => item.id === maintenanceForm[0]?.vehicleIds);
        let subTypeId = maintenanceForm[0]?.attributes?.serviceTypeId;
        try {
            const response = await instance({
                method: "GET",
                url: `api/expensetypes/subtype?expenseTypeId=${subTypeId}&search=`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            const subTypesData = response?.map(item => ({
                key: item.id,
                id: item.id,
                expenseTypeId: item.expenseTypeId,
                name: item.label,
                label: item.label,
                parentId: item.parentId,
            })) || [];

            setSubTypes(subTypesData);

            // Create a lookup map for subTypes
            const subTypeMap = subTypesData.reduce((acc, cur) => {
                acc[cur.id] = cur;
                return acc;
            }, {});

            let selectedServiceExpenseId = expenseType?.find(
                (item) => item.id === maintenanceForm[0]?.attributes?.serviceTypeId
            );

            let selectedUnit = { id: 0, label: "", value: 0 };

            const updatedForms = maintenanceForm.map((maintenanceForm1) => {
                let obj = { ...maintenanceForm1 };

                // Convert mileage-based attributes
                if (obj.attributes?.byMileage) {
                    obj.attributes.mileage = +(obj.attributes.mileage).toFixed(3);
                    obj.attributes.mileageInterval = +(obj.attributes.mileageInterval).toFixed(3);
                    obj.attributes.reminderBeforeMileage = +(obj.attributes.reminderBeforeMileage).toFixed(3);
                }

                // Convert hour-based attributes
                if (obj.attributes?.byHours) {
                    obj.attributes.hours = +(obj.attributes.hours / (1000 * 3600)).toFixed(3);
                    obj.attributes.hoursInterval = +(obj.attributes.hoursInterval / (1000 * 3600)).toFixed(3);
                    obj.attributes.reminderBeforeHours = +(obj.attributes.reminderBeforeHours / (1000 * 3600)).toFixed(3);
                }

                // Convert day-based attributes
                if (obj.attributes?.byDays) {
                    obj.attributes.daysInterval = +(obj.attributes?.daysInterval) || 1;
                    obj.attributes.reminderBeforeDays = +(obj.attributes?.reminderBeforeDays) || 1;
                }

                // Assign Service Sub-Type
                if (obj.attributes?.serviceExpenseTypeId) {
                    obj.attributes.serviceTypeId = selectedServiceExpenseId;
                    obj.attributes.serviceExpenseTypeId = subTypeMap[maintenanceForm1?.attributes?.serviceExpenseTypeId] || null;
                }

                // Prepare selected unit (only update once outside loop)
                if (maintenanceForm1?.deviceId) {
                    selectedUnit = {
                        id: maintenanceForm1.deviceId,
                        label: maintenanceForm1.deviceName,
                        value: maintenanceForm1.deviceId,
                    };
                }

                // Create a properly structured vehicle object
                let updatedVehicle = selectedVehicle
                    ? {
                        ...selectedVehicle,
                        label: selectedVehicle.vehicleLicensePlate,
                        value: selectedVehicle.id,
                        vehicleLP: selectedVehicle.vehicleLicensePlate,
                        valueType: "string",
                    }
                    : null;

                delete obj.progress;

                return {
                    ...obj,
                    vehicleIds: updatedVehicle,
                };
            });
            setSelectedUnit(selectedUnit);
            setSelectedReminder(updatedForms[0])
            setReminderForm((prevState) => ({
                ...prevState,
                ...updatedForms[0],
            }));

        } catch (error) {
            console.error("Error fetching subtypes:", error);
        }

        setIsEditForm(true);
        setIsCreateForm(true);
    };

    const handleDeleteReminder = () => {
        if (selectedReminder) {
            instance({
                url: `/api/poinvoices/${selectedReminder?.id}`,
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    if (selectedReminder?.id) {
                        setReminders((prev) => ({
                            ...prev,
                            data: prev?.data?.filter(item => item.id !== selectedReminder.id) || [],
                            total: Math.max(0, (prev?.total || 0) - 1),
                        }));
                    }
                    props.dispatch(notifySuccess(`Reminder Deleted Successfully`));
                    setSelectedReminder(null)
                    setIsDeleteReminder(false)
                }).catch(error => {
                    errorHandler(error, props.dispatch)
                    setSelectedReminder(null)
                    setIsDeleteReminder(false)
                })
        }
    }
    const isOpenDeleteReminder = (data) => {
        if (data) {
            setSelectedReminder(data[0])
        }
        setIsDeleteReminder(true)
    }
    const onCancelReminder = () => {
        setIsDeleteReminder(false)
        setSelectedReminder(null)
    }

    const handleChangeStatusReminder = async () => {
        if (!selectedReminder) return;
        const data = selectedReminder;
        const currentStatus = data?.attributes?.status;
        const updateStatus = currentStatus ? "disable" : "enable";
        const url = `/api/maintenance/${updateStatus}/${data?.id}`;
        try {
            const response = await instance.get(url, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            if (response) {
                props.dispatch(notifySuccess("Reminder Updated Successfully"));
                setIsEditForm(false);
                setIsCreateForm(false)
                setStatusMode(false);
                setIsChangeReminder(false);
                setVehicleIds([]);
                setTriggerApi((prev) => !prev)
                setSelectedReminder(null);
            }
        } catch (error) {
            setIsChangeReminder(false);
            props.dispatch(notifyError(error?.response?.data?.message || "Failed to update reminder."));
        }
    };


    const isOpenChangeStatus = (data) => {
        if (data) {
            setSelectedReminder(data)
        }
        setIsChangeReminder(true)
    }
    const isOpenViewListVehicleIds = (data) => {
        if (data[0]) {
            setSelectedReminder(data[0])
        }
        setIsViewListVehicleIds(true)
    }

    const isCancelViewListVehicleIds = () => {
        setIsViewListVehicleIds(false)
        setSelectedReminder(null)
    }

    const isCancelChangeStatus = () => {
        setIsChangeReminder(false)
        setSelectedReminder(null)
    }

    // useEffect(() => {
    //     if (statusMode) {
    //         submitForm()
    //     }

    // }, [statusMode])


    const handleVehiclesData = (data) => {
        let alltags = {
            tag1: [],
            tag2: [],
            tag3: [],
            tag4: [],
            tag5: [],
        }
        data?.data.forEach((t) => {
            if (t.attributes.tag_1) alltags.tag1.push(t.attributes.tag_1)
            if (t.attributes.tag_2) alltags.tag2.push(t.attributes.tag_2)
            if (t.attributes.tag_3) alltags.tag3.push(t.attributes.tag_3)
            if (t.attributes.tag_4) alltags.tag4.push(t.attributes.tag_4)
            if (t.attributes.tag_5) alltags.tag5.push(t.attributes.tag_5)
        })
        setTags(alltags)
        if (data) {
            const updatedData = data?.total
            setAllScrolableVehiclesLength(updatedData)
        }
    }

    const handleSubmitTagsFilter = (data) => {
        setFilterTags(data)
        setShowFilterModal(false)
    }

    const handleResetTagsFilter = () => {
        setFilterTags(null)
        setShowFilterModal(false)
    }
    const downloadMaintenance = (item) => {
        const Accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const api = `/api/maintenance/export/${item[0].id}`;
        axios({
            method: "GET",
            url: api,
            headers: {
                Accept: Accept,
            },
            responseType: "blob",
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement("a");
                a.href = url;
                a.setAttribute("download", "maintenance.xlsx");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch((error) => {
                props.dispatch(
                    notifyError(error || "somethingWentWrong")
                );
            });
    };
    const [showSingleOrderTable, setShowSingleOrderTable] = useState(false)
    const [selectedOrder, setSingleSelectedOrder] = useState(null)
    const handleCancelSingleOder = () => {
        setShowSingleOrderTable(false)
        setSaleOrderFilter((prev) => ({
            ...prev,
            from: "",
            fromDate: "",
            searchPlateNumber: "",
            searchValue: "",
            selectedDateTime: "",
            to: "",
            toDate: ""
        }))
    }

    const handleShowSingleOrder = ([selectedOrder]) => {
        setSingleSelectedOrder(selectedOrder?.id)
        setShowSingleOrderTable(true)
        fetchData(selectedOrder?.id, currentPage, pageSize, true);
    }
    const fetchData = useCallback(
        async (selectedOrder, page = currentPage, perPage = pageSize, reset = false) => {
            if (cancelSourceRef.current) {
                cancelSourceRef.current.cancel("Cancelled previous request");
            }
            cancelSourceRef.current = axios.CancelToken.source();

            const url = buildUrl(selectedOrder, page, perPage, saleOrderFilter);
            setIsFetchingSaleItems(true);
            try {
                const res = await axios.get(url, {
                    cancelToken: cancelSourceRef.current.token,
                });
                const responseData = res.data?.data || {};
                const list = responseData.data || [];
                const updatedItems = list.map((item) => ({
                    ...item,
                    check: false,
                }));
                setItemPagination((prevState) => ({
                    ...prevState,
                    page: responseData.page,
                    pageSize: responseData.pageSize,
                    total: responseData.total,
                    hasNext: responseData.hasNext,
                    items: reset ? updatedItems : [...prevState.items, ...updatedItems]
                }));
            } catch (err) {
                if (!axios.isCancel(err)) console.error(err);
            } finally {
                setIsFetchingSaleItems(false);
            }
        },
        [
            saleOrderFilter,
            selectedOrder,
            currentPage,
            pageSize,
        ]
    );

    const onPageChange = (page) => {
        setCurrentPage(page);
        fetchData(selectedOrder, page, pageSize, true);

    };

    const onRowsPerPageChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
        fetchData(selectedOrder, 1, size, true);

    };



    const handleDateTime = (e, date) => {
        showDates(e, date, props, setSaleOrderFilter);
    };

    const handleSaleOrderFilter = (name, value) => {
        setSaleOrderFilter((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSearch = () => {
        fetchData(selectedOrder, currentPage, pageSize, true);
    }
const handleClearSingleOrderFilter = () => {
    setSaleOrderFilter((prev) => ({
        ...prev,
        from: "",
        fromDate: "",
        selectedDateTime: null,
        to: "",
        toDate: ""
    }));
};

const handleSearchPo=(name,e)=>{
    console.error(name,e)
    setPoSearchValues((prev)=>({
        ...prev,
        [name]:e?.target?.value
    }))
}

const handleSubmitValuesPo=()=>{
    console.log("runing")
            setTriggerApi((prev) => !prev)
        setReminders((prevState) => ({
            ...prevState,
            page: 1
        }))
    
}

    return (
        <>
            <Grid container style={{ height: "100%" }}>
                <Grid item sm={12} xs={12} style={{marginTop:"0.5rem"}}>
                    {loading ? (
                            <Loader />
                    ) : (
                              <Table
                            {...props}
                            poSearchValues={poSearchValues}
                            handleSearchPo={handleSearchPo}
                            submitSearchValuesPo={handleSubmitValuesPo}
                            selected={props.selected}
                            handleChangeTabs={props.handleChangeTabs}
                            onShowModal={handleShowSingleOrder}
                            rows={
                                (reminders.data &&
                                    reminders.data) ||
                                []
                            }
                            pagination={setPagination(
                                reminders && reminders
                            )}
                            handleChangeRowsPerPage={(n) =>
                                handleChangeRowsPerPage(n, "maintenanceReminder")
                            }
                            handleChangePage={(n) =>
                                handleChangePage(n, "maintenanceReminder")
                            }
                            // hasAccessOfUpdate
                            isEditable
                            isShowPOButton
                            // isDownloadMaintenance
                            hasAccessOfDelete={checkPrivileges("porequestDelete")}
                            logInUser={props.logInUser}
                            themecolors={props.themecolors}
                            translate={props.translate}
                            vehicles={props?.vehicles || []}
                            ServerSetting={props.ServerSetting}
                            // searchableMaintenanceReminder
                            searchReminder={searchQuery}
                            SearchItem={SearchItem}
                            onEdit={handleEditReminder}
                            onDelete={isOpenDeleteReminder}
                            onStatusChange={isOpenChangeStatus}
                            isSearchApi={handleSearchApi}
                            isSearchApiBtn
                            createForm={createForm}
                            isCreateForm={isCreateForm || props.selectedTab === "predictive"}
                            // isShowReminderHeader
                            showReminders={props.showReminders}
                            downloadInvoicePdf={downloadMaintenance}
                            isShowSingleOrderIcon
                            // completeMark
                            hasAccessOfCreate
                            listViewVehicleIds={isOpenViewListVehicleIds}
                            // status={checkPrivileges("maintenanceUpdate")}
                            createButton
                            invoiceLabel
                            // createButton={
                            //     // checkPrivileges('invoiceCreate') && (
                            //     <div style={{ marginLeft: 10 }}>
                            //         <Button onClick={createForm}>
                            //             {props.translate('Create')}
                            //         </Button>
                            //     </div>
                            //     // )
                            // }
                            rowDefinition={createRowDefinition(props.translate)}
                        />
                    )}
                </Grid>
            </Grid>
            {showSingleOrderTable &&
                <ConfirmDialoag
                    onCancel={handleCancelSingleOder}
                    onOk={handleCancelSingleOder}
                    hideCancel
                    OkText={'Ok'}
                    // title={props.translate('Sale Order DNs')}
                    maxWidth={"lg"}
                    children={
                        <EnhancedTable
                            rows={itemPagination.items}
                            rowDefinition={columns}
                            title="Sale Order DNs"
                            searchable
                            handleClearSingleOrderFilter={handleClearSingleOrderFilter}
                            createButton={false}
                            showCheckbox={false}
                            isEditable={true}
                            canUpdate={false}
                            canDelete={false}
                            canViewDn={true}
                            canDownloadPdf={true}
                            isSaleOrderHeader={true}
                            handleSearch={handleSearch}
                            handleDateTime={handleDateTime}
                            saleOrderFilter={saleOrderFilter}
                            handleSaleOrderFilter={handleSaleOrderFilter}
                            // isBack
                            // onBack={handleBack}
                            // onSelectionChange={handleSelectionChange}
                            onPageChange={onPageChange}
                            page={currentPage}
                            totalData={itemPagination.total}
                            rowsPerPage={pageSize}
                            isLoading={isFetchingSaleItems}
                            onRowsPerPageChange={onRowsPerPageChange}
                            translate={props.translate}
                        />
                    }
                />
            }
            {isDeleteReminder && (
                <ConfirmDialoag
                    onCancel={onCancelReminder}
                    onOk={handleDeleteReminder}
                    title={props.translate('areYouWantToDelete')}
                    children={selectedReminder?.name}
                />
            )}
        </>
    )
}

export default SalesOrder

